// /src/i18n/format.js
// Простой модуль форматирования, завязанный на текущий языковой префикс URL.
// Не меняет UI сам по себе — импортируй и используй там, где нужно.

export function detectLangFromPath(pathname = (typeof window !== 'undefined' ? window.location.pathname : '/')) {
  const seg = (String(pathname).split('/').filter(Boolean)[0] || '').toLowerCase();
  return ['uk', 'en', 'it', 'fr'].includes(seg) ? seg : 'uk';

}

export function getLocale() {
  // Прямое соответствие BCP-47: uk → uk-UA, en → en-US (по умолчанию), it → it-IT
  // Если потребуется — можно расширить карту локалей без правки потребителей.
  const lang = detectLangFromPath();
  const map = { uk: 'uk-UA', en: 'en-US', it: 'it-IT', fr: 'fr-FR' };

  return map[lang] || 'uk-UA';
}

export function useLocale() {
  return getLocale();
}

export function fmtDateTime(dateLike, localeOrOpts = {}, maybeOpts = {}) {
  if (!dateLike) return '';
  const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
  if (isNaN(d.getTime())) return '';
  let locale = getLocale();
  let opts = {};
  if (typeof localeOrOpts === 'string') {
    locale = localeOrOpts;
    opts = maybeOpts;
  } else if (localeOrOpts && typeof localeOrOpts === 'object') {
    opts = localeOrOpts;
  }
  // Базовый набор безопасных полей; потребитель может переопределить через opts
  const base = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
  return new Intl.DateTimeFormat(locale, { ...base, ...opts }).format(d);
}

export function fmtDate(dateLike, opts = {}) {
  if (!dateLike) return '';
  const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
  if (isNaN(d.getTime())) return '';
  const locale = getLocale();
  const base = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return new Intl.DateTimeFormat(locale, { ...base, ...opts }).format(d);
}

export function fmtNumber(value, localeOrOpts, maybeOpts = {}) {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (!isFinite(n)) return String(value);
  let locale = getLocale();
  let opts = {};
  if (typeof localeOrOpts === 'string') {
    locale = localeOrOpts;
    opts = maybeOpts;
  } else if (localeOrOpts && typeof localeOrOpts === 'object') {
    opts = localeOrOpts;
  }
  return new Intl.NumberFormat(locale, opts).format(n);
}

export function fmtMoney(value, currency = 'UAH', opts = {}) {
  if (value == null || value === '') return '';
  const n = Number(value);
  if (!isFinite(n)) return String(value);
  const locale = getLocale();
  const base = { style: 'currency', currency, maximumFractionDigits: 2 };
  return new Intl.NumberFormat(locale, { ...base, ...opts }).format(n);
}
